// extracted by mini-css-extract-plugin
export var acitonButtons = "_gb-0";
export var additionalIcon = "_gb-f";
export var block = "_gb-1";
export var blockContent = "_gb-7";
export var blockDescription = "_gb-8";
export var blockIcon = "_gb-9";
export var blockTitle = "_gb-6";
export var border = "_gb-a";
export var center = "_gb-l";
export var edge = "_gb-b";
export var edgeLabel = "_gb-c";
export var edgePath = "_gb-d";
export var error = "_gb-e";
export var flowchart = "_gb-g";
export var flowchartContent = "_gb-h";
export var highlighted = "_gb-3";
export var hover = "_gb-4";
export var icon = "_gb-i";
export var left = "_gb-m";
export var navButton = "_gb-j";
export var navButtons = "_gb-k";
export var right = "_gb-n";
export var selected = "_gb-2";
export var small = "_gb-5";